
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
components: {
Tab,
TabItem,
},
data() {
return {
ID:'',
selectTab: ''
}
},
created() {
this.selectTab = this.$route.name
this.ID = this.$route.query.ID || ''
},
deactivated() {
this.$destroy()
},
methods: {
handler(type) {
if (this.$route.name == type) return
this.$router.replace({
path: './' + type,
query: {
ID: this.ID
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/bmw/th/Index.vue